module.exports = __webpack_public_path__ + "img/land_11.bc053c80.jpg";